export const CollectionConst = {
    collectionSubType: {
        COD: 'COD',
        LPA: 'LPA',
    },
    refundType: {
        ITEM_NEW: 'LPA CLosure',
        ITEM_INPUT: 'Payment Receipt',
    },
    refundStatus: {
        ITEM_NEW: 'New Request Generated',
        ITEM_INPUT: 'Extra Data Inputted',
        ITEM_VERIFIED: 'Verified',
        ITEM_APPROVED: 'Approved',
        ITEM_PROCESSED: 'Bank Instruction Processed',
        ITEM_ISSUED: 'Pay Order Issued',
        ITEM_REFUNDED: 'Refunded',
        ITEM_ADJUSTED: 'Adjusted',
    },
}